import { render, staticRenderFns } from "./UserMgmt.vue?vue&type=template&id=5c810dd2&scoped=true"
import script from "./UserMgmt.vue?vue&type=script&lang=js"
export * from "./UserMgmt.vue?vue&type=script&lang=js"
import style0 from "./UserMgmt.vue?vue&type=style&index=0&id=5c810dd2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c810dd2",
  null
  
)

export default component.exports